// extracted by mini-css-extract-plugin
export default {"preview":"DDsyV5xM7S","preview_readonly":"aQQwh4q3tg"};